export default __webpack_public_path__ + "static/media/water_seamless_transp.ae3fdca5.webp";